import React from 'react';

type IRepoIconProps = React.SVGProps<SVGSVGElement>;

const RepoIcon: React.FC<IRepoIconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M12 0.5H4.44216L0 4.93979V12.5H5.05984V5.55713H12V0.5Z"
        fill="white"
      />
      <path
        d="M9.17031 12.5017C10.7335 12.5017 12.0008 11.2351 12.0008 9.6727C12.0008 8.11031 10.7335 6.84375 9.17031 6.84375C7.60709 6.84375 6.33984 8.11031 6.33984 9.6727C6.33984 11.2351 7.60709 12.5017 9.17031 12.5017Z"
        fill="white"
      />
    </svg>
  );
};

export default RepoIcon;
